import type { default as GSAPType } from 'gsap';
import type { default as ScrollTriggerType } from 'gsap/ScrollTrigger';

interface GSAPModules {
  gsap: typeof GSAPType;
  ScrollTrigger: typeof ScrollTriggerType;
}

let cached: GSAPModules | null = null;
let loading: Promise<GSAPModules> | null = null;

export function loadGSAP(): Promise<GSAPModules> {
  if (cached) return Promise.resolve(cached);
  if (!loading) {
    loading = Promise.all([import('gsap'), import('gsap/ScrollTrigger')]).then(
      ([g, st]) => {
        const gsap = g.default || g.gsap;
        const ScrollTrigger = st.default || st.ScrollTrigger;
        gsap.registerPlugin(ScrollTrigger);
        cached = { gsap, ScrollTrigger };
        return cached;
      }
    );
  }
  return loading;
}
